import React from "react"

import { graphql, useStaticQuery } from "gatsby"

import Layout from "../../components/Layouts/mainPage"
import { PageData } from "../../interfaces/pageProps"
import { getPageData } from "../../helpers/getPageData"
import {
  Banner,
  Advantages,
  LiteBanner,
  TwoBlocks,
  FourBlocks,
  QuestionsAnswers,
  Form,
  Header,
  Footer,
  Slider,
  Partners,
  Calculator,
} from "../../components/RedesignPkw"

export default function ABPkwPage() {
  const data: PageData = useStaticQuery(graphql`
    query {
      allDynamicBanner {
        edges {
          node {
            name
            deskGatsbyImg {
              url
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  quality: 80
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                  breakpoints: [1920, 3840]
                )
              }
            }
            mobGatsbyImg {
              url
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  quality: 80
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                  breakpoints: [600, 1200]
                )
              }
            }
          }
        }
      }
      admin {
        page(url: "https://halvacard.ru/order/pkw/") {
          url
          ligal {
            text
          }
          notIndex
        }
      }
    }
  `)

  const { noIndex } = getPageData(data)

  const countDownTime = 1799999

  return (
    <Layout
      noHeader
      noFooter
      noIndex={noIndex}
      seoData={{
        title: "Рассрочка* от 10 месяцев по карте Халва",
      }}
    >
      <Header isHint isCountdown countDownTime={countDownTime} />
      <Banner orderNum="2" />
      <Advantages orderNum="3" />
      <Advantages
        orderNum="4"
        variantStyle="threeSteps"
        headTitle="Всего три шага"
        data="THREE_STEPS_ITEMS"
      />
      <Form
        countDownTime={countDownTime}
        variant="redesignPkw"
        progressBar
        dataLayerName="shortPersonalForm"
        headTitle="Оформить карту"
        longTitle
        additionalEventInDataLayer
        withTimer
        formBtnText="Оформить карту"
        orderNum="5"
        isGreenApprove
      />
      <Calculator orderNum="6" />
      <FourBlocks
        styleVariant="base"
        orderNum="7"
        headTitle="Множество преимуществ"
        dataVariant="download"
      />
      <TwoBlocks orderNum="8" variant="download" />
      <Slider
        orderNum="9"
        headTitle="Что дает подписка «Халва.Десятка»"
        headDescr="Подключим на месяц бесплатно, чтобы вы попробовали все преимущества"
      />
      <LiteBanner
        orderNum="10"
        headTitle="Подписка «Халва.Десятка»"
        headDescr="Первый месяц 0 ₽, далее 399 ₽ в месяц"
        dataVariant="subscription"
        styleVariant="subscription"
      />
      <Partners orderNum="11" />
      <LiteBanner
        orderNum="12"
        headTitle={
          <>
            Управляйте рассрочкой* <br />
            в&nbsp;приложении
          </>
        }
        headDescr="График и размер ежемесячных платежей не&nbsp;в&nbsp;голове, а&nbsp;в&nbsp;смартфоне"
        dataVariant="download"
        styleVariant="download"
      />
      <QuestionsAnswers orderNum="13" headTitle="Вопросы и ответы" />
      <Footer withSocialLinks orderNum="14" />
    </Layout>
  )
}
